var parts = ['select', 'navigator', 'sizing', 'result'];
var selectStyles = {
  width: 'max-content',
  height: 'fit-content',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: 'md',
  select: {
    paddingInlineEnd: '2rem',
    width: '100%',
    minWidth: '0px',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    position: 'relative',
    appearance: 'none',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    background: 'inherit',
    paddingBottom: '1px',
    lineHeight: 'normal',
    fontSize: 'md',
    paddingInlineStart: '4',
    height: '8',
    borderRadius: 'md',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderImage: 'initial',
    borderColor: 'inherit',
    cursor: 'pointer',
    '&::-ms-expand': {
      display: 'none'
    }
  },
  svg: {
    fontSize: '1.2em',
    pointerEvents: 'none',
    position: 'absolute',
    right: '2',
    top: '50%',
    transform: 'translate(2px, -50%)'
  }
};
var sizingStyles = {
  alignItems: 'center',
  display: 'flex',
  gap: '5px',
  justifyContent: 'center'
};
var navigatorStyles = {
  alignItems: 'center',
  display: 'flex',
  gap: '7px',
  svg: {
    cursor: 'pointer'
  },
  nav: {
    display: 'flex',
    gap: '5px'
  },
  'nav > div': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    maxW: '32px',
    minW: '32px',
    overflow: 'hidden',
    position: 'relative'
  },
  button: {
    display: 'inline-flex',
    appearance: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    position: 'relative',
    whiteSpace: 'nowrap',
    verticalAlign: 'baseline',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    width: 'auto',
    lineHeight: 'normal',
    borderRadius: 'base',
    fontWeight: 700,
    border: 'none',
    height: 'auto',
    minWidth: '8',
    fontSize: 'sm',
    paddingInlineStart: '3',
    paddingInlineEnd: '3',
    padding: '2px',
    transition: 'none 0s ease 0s',
    _hover: {
      textDecor: 'underline'
    }
  }
};
var resultStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '7px'
};

var baseStyle = () => ({
  select: selectStyles,
  navigator: navigatorStyles,
  result: resultStyles,
  sizing: sizingStyles
});

export default {
  parts,
  baseStyle
};
//# sourceMappingURL=Pagination.js.map